import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { LangProvider } from '@ksa/ui'

// ⚠️ THE FONTS ARE SELF-HOSTED, NOT LINKED FROM A CDN. Everything a customer types into this
// application is their business's copy before it is public; a font request to a third party tells
// that third party who is building a site and when. It is also the rule the published sites are held
// to (`@ksa/render` uses system fonts entirely), and holding ourselves to a weaker version of our
// own rule is how the rule stops being one.
import '@fontsource-variable/readex-pro'
import '@fontsource/ibm-plex-sans-arabic/400.css'
import '@fontsource/ibm-plex-sans-arabic/600.css'
import '@fontsource/ibm-plex-sans-arabic/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/600.css'

import '@ksa/ui/ui.css'
// The CUSTOMER's stylesheet, for the editor's live preview. Loaded here so the preview looks exactly
// like the published page — the same file the publisher writes into R2.
import '@ksa/render/site.css'

import { App } from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <LangProvider>
        <App />
      </LangProvider>
    </BrowserRouter>
  </StrictMode>,
)
